import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import DisclaimerPage from "../pages/disclaimer/page";
import PrivacyPage from "../pages/privacy-policy/page";
import TermsPage from "../pages/terms/page";
import SafetyPage from "../pages/safety/page";
import FaqPage from "../pages/faq/page";
import GuidesPage from "../pages/guides/page";
import ReviewsPage from "../pages/reviews/page";
import ShippingPage from "../pages/shipping/page";
import WarehousePage from "../pages/warehouse/page";
import QcPage from "../pages/qc/page";
import CouponPage from "../pages/coupon/page";
import ComparisonPage from "../pages/comparison/page";
import SpreadsheetPage from "../pages/spreadsheet/page";
import CategoriesPage from "../pages/categories/page";
import CssbuyReviewPage from "../pages/reviews/cssbuy-review/page";
import IsCssbuyLegitPage from "../pages/reviews/is-cssbuy-legit/page";
import CssbuyShippingCostPage from "../pages/shipping/cssbuy-shipping-cost/page";
import CssbuyWarehousePage from "../pages/warehouse/cssbuy-warehouse/page";
import CssbuyQcGuidePage from "../pages/qc/cssbuy-qc-guide/page";
import CssbuyCouponPage from "../pages/coupon/cssbuy-coupon/page";
import CssbuySpreadsheetCompleteGuide from "../pages/spreadsheet/cssbuy-spreadsheet-complete-guide/page";
import HowToUseCssbuySpreadsheet from "../pages/guides/how-to-use-cssbuy-spreadsheet/page";
import CssbuySpreadsheetBeginnerGuide from "../pages/guides/cssbuy-spreadsheet-beginner-guide/page";
import CssbuyShoesSpreadsheet from "../pages/spreadsheet/cssbuy-shoes-spreadsheet/page";
import CssbuySneakersSpreadsheet from "../pages/spreadsheet/cssbuy-sneakers-spreadsheet/page";
import CssbuyHoodiesSpreadsheet from "../pages/spreadsheet/cssbuy-hoodies-spreadsheet/page";
import CssbuyTaobaoGuide from "../pages/guides/cssbuy-taobao-guide/page";
import CssbuyWeidianGuide from "../pages/guides/cssbuy-weidian-guide/page";
import CssbuyYupooGuide from "../pages/guides/cssbuy-yupoo-guide/page";
import CssbuyVsSuperbuy from "../pages/comparison/cssbuy-vs-superbuy/page";
import CssbuyAlternatives from "../pages/comparison/cssbuy-alternatives/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/disclaimer", element: <DisclaimerPage /> },
  { path: "/privacy-policy", element: <PrivacyPage /> },
  { path: "/terms", element: <TermsPage /> },
  { path: "/safety", element: <SafetyPage /> },
  { path: "/faq", element: <FaqPage /> },
  { path: "/guides", element: <GuidesPage /> },
  { path: "/reviews", element: <ReviewsPage /> },
  { path: "/reviews/cssbuy-review", element: <CssbuyReviewPage /> },
  { path: "/reviews/is-cssbuy-legit", element: <IsCssbuyLegitPage /> },
  { path: "/shipping", element: <ShippingPage /> },
  { path: "/shipping/cssbuy-shipping-cost", element: <CssbuyShippingCostPage /> },
  { path: "/warehouse", element: <WarehousePage /> },
  { path: "/warehouse/cssbuy-warehouse", element: <CssbuyWarehousePage /> },
  { path: "/qc", element: <QcPage /> },
  { path: "/qc/cssbuy-qc-guide", element: <CssbuyQcGuidePage /> },
  { path: "/coupon", element: <CouponPage /> },
  { path: "/coupon/cssbuy-coupon", element: <CssbuyCouponPage /> },
  { path: "/comparison", element: <ComparisonPage /> },
  { path: "/spreadsheet", element: <SpreadsheetPage /> },
  { path: "/spreadsheet/cssbuy-spreadsheet-complete-guide", element: <CssbuySpreadsheetCompleteGuide /> },
  { path: "/guides/how-to-use-cssbuy-spreadsheet", element: <HowToUseCssbuySpreadsheet /> },
  { path: "/guides/cssbuy-spreadsheet-beginner-guide", element: <CssbuySpreadsheetBeginnerGuide /> },
  { path: "/spreadsheet/cssbuy-shoes-spreadsheet", element: <CssbuyShoesSpreadsheet /> },
  { path: "/spreadsheet/cssbuy-sneakers-spreadsheet", element: <CssbuySneakersSpreadsheet /> },
  { path: "/spreadsheet/cssbuy-hoodies-spreadsheet", element: <CssbuyHoodiesSpreadsheet /> },
  { path: "/guides/cssbuy-taobao-guide", element: <CssbuyTaobaoGuide /> },
  { path: "/guides/cssbuy-weidian-guide", element: <CssbuyWeidianGuide /> },
  { path: "/guides/cssbuy-yupoo-guide", element: <CssbuyYupooGuide /> },
  { path: "/comparison/cssbuy-vs-superbuy", element: <CssbuyVsSuperbuy /> },
  { path: "/comparison/cssbuy-alternatives", element: <CssbuyAlternatives /> },
  { path: "/categories", element: <CategoriesPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;